import React, { useEffect, useState } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import useStateRef from 'react-usestateref'
import BreadCrumbsContainer from '../BreadCrumbs/BreadCrumbsContainer';
import Helper from '../Helper';
import { APPLICATION_JSON } from '../../middleware/types';
import Loader from '../Loader';
import { useSelector, useDispatch } from 'react-redux';
import { miniCartItemCountAction } from '../../middleware/miniCartItemCountAction'
import { Modal } from '../Modal/Modal';
import MyAccountCommonize from './MyAccountCommonize';
import { getShoppingListDetails } from '../../middleware/getShoppingListDetails';
import { getProfileDetailsAction } from '../../middleware/getProfileDetailsAction';
import { updateProfileDetailsAction } from '../../middleware/updateProfileDetailsAction';
import { updateShoppingListDetailsAction } from '../../middleware/updateShoppingListDetailsAction';
import CbMobileLogOut from './CbMobileLogOut';

function ShoppingList({ containerObject, templateName, contentId, dataZone }) {
    const [hasError, setHasError, setHasErrorRef] = useStateRef(false);
    const [responseListRef, setResponseList] = useState()
    const [selectedProductIds, setSelectedProductIds,selectedProductIdsRef] = useStateRef()
    const [shoppingListErrorMsg, setShoppingListErrorMsg, shoppingListErrorMsgRef] = useStateRef(false);
    const [isModalopen, setIsModalOpen] = useState(false);
    const [addListToCart, setAddListToCart, addListToCartRef] = useStateRef()
    const [invalidProduct, setInvalidProduct, invalidProductRef] = useStateRef("");
    const [error, setError, errorRef] = useStateRef()
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory()
    //const [selectedLists, setSelectedIds] = useState(selectedLists?selectedLists:"");
    const [selectedLists, setState] = React.useState({});
    const [giftId, setGiftId, giftIdRef] = useStateRef()
    const dispatch = useDispatch();
    const [selectedId, setSelectedId, selectedIdRef] = useStateRef({});
    const [sortField, setSortField] = useState()
    const [order, setOrder] = useState('default')
    const [listDeleteError, setListDeleteError] = useState("true");
    const [listDeleteSuccess, setListDeleteSuccess, listDeleteSuccessRef] = useStateRef('false');
    const location = useLocation();
    var listDelete = location.state ? location.state : '';
    const [eventNameAccend, setEventNameAccend] = useState(true);
    const [creationDateAccend, setCreationDateAccend] = useState(true);
    const [quantityAccend, setQuantityAccend] = useState(true);
    const [totalAccend, setTotalAccend] = useState(true);
    const updateShoppingListDetails = useSelector(state => state.updateShoppingListDetailsReducer)
    //from reducer state
    const GetCartCount = useSelector(state => state.miniCartItemCountReducer.response.payload)
    const profileDetails = useSelector(state => state.getProfileDetails.profileDetails)
    const [urlParm, setUrlParm] = useState()
    const loaderStatus = useSelector(state => state.getLoaderStatus.loaderStatus)
    //breadcrumbs object 
    const breadCrumbs = {
        "ancestors": [{
            label: "My Account",
            link: "/account/landing"
        }],
        productName: "Shopping Lists"
    };
    // const location = useLocation();
    // const successMsgState = location.state;
    // console.log('successMsgState---List page', successMsgState)
    useEffect(() => {
        var url = history.location.pathname
        console.log("login-page-url", url)
        var splitedUri = url.split("/")
        console.log("splitedUri", splitedUri)
        console.log("splitedUri[1]", splitedUri[1])
        splitedUri && splitedUri[1] && splitedUri[2] ? setUrlParm(splitedUri[1] + "/" + splitedUri[2]) : "";

        if (profileDetails) {
            if (profileDetails && profileDetails.transient && urlParm && urlParm == "account/list") {
                history.push("/account/login")
            }
        }
    }, [profileDetails])

    useEffect(() => {

        if (listDelete === 'true') {
            document.getElementById("delete-success")?.classList.remove("d-none")
            document.getElementById("delete-success")?.classList.add("d-block")
        }
    }, [listDelete])

    useEffect(() => {
        if (loaderStatus == true) {
            console.log("log in shoppingList page loader true");
        } else {
            console.log("log in shoppingList page loader false");
            if (window.location.pathname == "/account/list") {
                fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/shopping-list/shopping-list-details`, {
                    method: 'GET'
                }).then(res => res.json())
                    .then(res => {
                        if (res.result == "success") {
                            var shoppingListDetatils = (JSON.parse(res.response)).response
                            setResponseList(shoppingListDetatils)
                        } else {
                            console.log("Error result ---->>>>", res)
                        }
                    })
            }
        }

    }, [])


    const handleShoppingListSearch = (event) => {
        event.preventDefault();
        var formData = new FormData(event.target);
        //const formValue = Object.fromEntries(formData.entries());
        var shoppingListSearch = formData.get("searchProduct");

        const inputMap = {
            searchParam: shoppingListSearch,
            searchLists: "true",
            publicLists: "false"
        }
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/shopping-list/shopping-list-search`, {
            method: 'POST',
            headers: new Headers({
                "content-Type": "application/json",
            }),
            body: JSON.stringify(inputMap)
        }).then(res => res.json())
            .then(res => {
                if (res.result == "success") {
                    var shoppingListDetatils = (JSON.parse(res.response)).response.matchedList
                    setResponseList(shoppingListDetatils)
                    document.getElementById("list-error-id").classList.remove("d-block");
                    document.getElementById("list-error-id").classList.add("d-none");
                } else {
                    var error = (JSON.parse(res.response)).response
                    setError(JSON.parse(error).errors)
                    document.getElementById("list-error-id").classList.remove("d-none");
                    document.getElementById("list-error-id").classList.add("d-block")
                }
            })
    }

    const handleFindFriendShoppingList = (event) => {
        event.preventDefault();
        var formData = new FormData(event.target);
        var emailList = formData.get("emailList");

        const inputMap = {
            emailList: emailList.trim()
        }
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/shopping-list/find-friends`, {
            method: 'POST',
            headers: new Headers({
                "content-Type": "application/json",
            }),
            body: JSON.stringify(inputMap)
        }).then(res => res.json())
            .then(res => {
                if (res.result == "success") {
                    document.getElementById("find-friend-error").innerHTML = ""
                    document.getElementById("find-friend-error").classList.add("d-none");
                    // <ListPublic id={res.id} />
                    document.getElementById("findFriendClose").click()
                    history.push(res.returnUrl)
                } else {
                    document.getElementById("find-friend-error").innerHTML = res.response;
                    document.getElementById("find-friend-error").classList.remove("d-none");
                    document.getElementById("find-friend-error").classList.add("d-block")
                }
            })
    }

    const handleChangeCheckbox = (event) => {
        var checkbox = document.getElementById("listList")
        var checkboxId = checkbox.getElementsByClassName("form-check-input")
        var selectedLists = [];
        var deletedIds = null;
        for (var i = 0; i < checkboxId.length; i++) {
            if (checkboxId[i].checked === true) {
                selectedLists.push(checkboxId[i].id)
            }

            if (selectedLists.length > 0) {
                deletedIds = selectedLists.join(",")
                setState(deletedIds);
            }
        }
    }

    const handleIndividualChecked = (event) => {
        var selected = [];
        var tables = document.getElementById("listList");
        var chks = tables.getElementsByClassName("form-check-input");
        console.log("chks", chks)
        for (var i = 0; i < chks.length; i++) {
            if (chks[i].checked) {
                selected.push(chks[i].id);
            } else {
                document.getElementById("checkboxNoLabel").checked = false;
            }
        }
        console.log("handleIndividualChecked selected",selected);
        setSelectedProductIds(selected)
        setState(selected);
    };

    const handleSelectAllCheckbox = (event) => {
        var selected = [];
        var tables = document.getElementById("listList");
        var chks = tables.getElementsByClassName("form-check-input");
        for (var i = 0; i < chks.length; i++) {
            if (event.target.checked) {
                chks[i].checked = true;
            } else {
                chks[i].checked = false;
            }
            if (chks[i].checked) {
                selected.push(chks[i].id);
            }
            setSelectedProductIds(selected)
            setState(selected);
        }
    };

    async function handleAddMultiShoppingListToCart(event) {
        event.preventDefault();
        Helper.clearErrorMsg()
        setShoppingListErrorMsg()
        handleIndividualChecked()
        // setIsLoading(true)
        var index = 0
        console.log("handleAddMultiShoppingListToCart selectedProductIds",selectedProductIdsRef.current);
        const selectedListsInArray = selectedProductIdsRef.current && selectedProductIdsRef.current ? selectedProductIdsRef.current : []
        if (selectedListsInArray.length > 0) {
            var actionUrl = "api/rest/cb/shopping-list/shopping-list-details/add-multiple-products-to-cart";
            var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
            var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({ selectedLists: selectedListsInArray }))
            if (res.result == "success") {
                //updating mini cart count
                dispatch(updateProfileDetailsAction(true, "cart"));
                setAddListToCart((JSON.parse(res.response)).response.response.validproducts)
            //    handleSiteSpecDataLayer((JSON.parse(res.response)).response.response.validproducts)
                if ((JSON.parse(res.response)).response.response.invalidProducts &&
                    (JSON.parse(res.response)).response.response.invalidProducts.length > 0) {
                    setInvalidProduct((JSON.parse(res.response)).response.response.invalidProducts)
                } else {
                    setInvalidProduct()
                }
                setIsModalOpen(true)
                // updating cart count
                var Url = `${window.location.protocol}//${window.location.hostname}/api/rest/cb/checkout/mini-cart-count`
                var addListBtn = document.getElementById("addList");
                addListBtn.setAttribute("data-bs-toggle", "modal");
                addListBtn.setAttribute("data-bs-target", `#addProductToCartModal${index}`);
                addListBtn.click();
                setIsLoading(false)
                window.dataLayer = window.dataLayer || []
                if (window.dataLayer.length > 0) {
                    window.dataLayer.push({ "event": "list_detail_add_cart_list" })
                }
            }
            else {
                setShoppingListErrorMsg((JSON.parse(res.response)).errorMessage[0].message)
                setIsLoading(false)
            }
        } else {
            setShoppingListErrorMsg("Please choose at least one shopping list to add the items from that list to your Cart.")
            setIsLoading(false)
        }
    }

    function handleSiteSpecDataLayer(validateProduct) {
        console.log("handleSiteSpecDataLayer firedddddd", validateProduct);
        let productList = []
        {
            validateProduct?.map((oneProduct) => {
                let categoryList = [];
                let category = JSON.parse(oneProduct?.dataLayer_obj)
                const categoryList1 = [category["dataLayer_obj.productSubCat1"] && category["dataLayer_obj.productSubCat1"], category["dataLayer_obj.productSubCat2"] && category["dataLayer_obj.productSubCat2"], category["dataLayer_obj.productSubCat3"] && category["dataLayer_obj.productSubCat3"], category["dataLayer_obj.productSubCat4"] && category["dataLayer_obj.productSubCat4"]];

                categoryList = categoryList1;
                const productMapDuplicate = {
                    "productId": oneProduct.ProductId,
                    "category": categoryList
                }
                let productMap = productMapDuplicate;
                productList.push(productMap)
            })
        }

        const page = {
            "type": "product",
            "products": productList
        }
        const ShoppingList_payload = {
            "page": page
        }
        window.ssRecsInfo = window.ssRecsInfo || {}
        window.ssRecsInfo = ShoppingList_payload
        window.dispatchEvent(new CustomEvent("sitespect-user-action", { 'detail': ShoppingList_payload}))
    }

    const handleDeleteClick = (event) => {
        event.preventDefault();
        var flag = confirm("Are you sure you want to delete selected shopping lists?");

        if (flag) {
            const inputMap = {
                selectedLists: selectedLists
            }
            fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/shopping-list/delete-list`, {
                method: 'POST',
                headers: new Headers({
                    "content-Type": "application/json",
                }),
                body: JSON.stringify(inputMap)
            }).then(res => res.json())
                .then(res => {
                    if (res.result == "success") {
                        console.log('res...', res);
                        console.log('delete succesfully...');
                        setState();
                        console.log('res.returnUrl...', res);
                        setListDeleteSuccess('true');
                        history.push('/account/list', listDeleteSuccessRef.current);
                    } else {
                        console.log("res.response", res.response)
                        setError(res.response)
                        document.getElementById("list-error-id").classList.remove("d-none")
                        document.getElementById("list-error-id").classList.add("d-block")
                    }
                })
            window.dataLayer = window.dataLayer || []
            if (window.dataLayer.length > 0) {
                window.dataLayer.push({ "event": "listDetailDelete" })
            }
        }

    }

    const handleRemoveOneShoppingItem = (event) => {
        event.preventDefault();
        var selectedIdList = [];
        var prodId = event.currentTarget.id
        selectedIdList.push(prodId)
        setSelectedId(selectedIdList);
        if (confirm("Are you sure you want to delete this shopping list?")) {
            const inputMap = {
                selectedLists: selectedIdRef.current
            }
            fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/shopping-list/delete-list`, {
                method: 'POST',
                headers: new Headers({
                    "content-Type": "application/json",
                }),
                body: JSON.stringify(inputMap)
            }).then(res => res.json())
                .then(res => {
                    if (res.result == "success") {

                        console.log('res.returnUrl,...', res.returnUrl);
                        setListDeleteSuccess('true');
                        history.push('/account/list', listDeleteSuccessRef.current);
                        // history.push(res.returnUrl, listDeleteError)
                        //location.reload()
                    } else {
                        console.log("delete-list", "errorrrrr")
                    }
                })
        }
        window.dataLayer = window.dataLayer || []
        if (window.dataLayer.length > 0) {
            window.dataLayer.push({ "event": "listDetailDelete" })
        }
    }

    const handleCopy = (event) => {
        // setGiftId(event)
        // var copyModal = document.getElementById("copy-modal-id");
        // copyModal.setAttribute("data-bs-toggle", "modal");
        // copyModal.setAttribute("data-bs-target", "#copyListModal");
        // copyModal.click();
        window.dataLayer = window.dataLayer || []
        if (window.dataLayer.length > 0) {
            window.dataLayer.push({ "event": "list_detail_copy" })
        }
    }

    const emailButtonClose = (event) => {
        var index = event.currentTarget.getAttribute('index')
        document.getElementById(`share-list-error-div${index}`).classList.remove("d-block")
        document.getElementById(`share-list-error-div${index}`).classList.add("d-none")
        document.getElementById("emailIput").value = "";
        document.getElementById("notesTextArea").value = "";
    }

    const handleSorting = (sortField, sortOrder) => {
        if (sortField) {
            const sorted = [...responseListRef].sort((a, b) => {
                if (a[sortField] === null) return 1;
                if (b[sortField] === null) return -1;
                if (a[sortField] === null && b[sortField] === null) return 0;
                return (
                    a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
                        numeric: true,
                    }) * (sortOrder === "asc" ? 1 : -1)
                );
            }
            );

            setResponseList(sorted);
        }
    }

    const handleSortingChange = (event) => {

        document.getElementById("eventName").classList.remove("sort-up")
        document.getElementById("eventName").classList.remove("sort-down")
        document.getElementById("creationDate").classList.remove("sort-up")
        document.getElementById("creationDate").classList.remove("sort-down")
        document.getElementById("quantity").classList.remove("sort-up")
        document.getElementById("quantity").classList.remove("sort-down")
        document.getElementById("total").classList.remove("sort-up")
        document.getElementById("total").classList.remove("sort-down")
        // let accessor = event.currentTarget.getAttribute('data-id')
        // const sortOrder =
        //     accessor === sortField && order === "asc" ? "desc" : "asc";
        // setSortField(accessor);
        // setOrder(sortOrder);
        // handleSorting(accessor, sortOrder);


        var tables = document.getElementById("listList");
        var chks = tables.getElementsByClassName("form-check-input");
        console.log("chks", chks)
        for (var i = 0; i < chks.length; i++) {
           
                document.getElementById(chks[i].id).checked = false;
            
        }
        setSelectedProductIds()
        setState();
        var accend = true
        if (event == "eventName") {
            accend = eventNameAccend
            if (eventNameAccend == true) {
                document.getElementById("eventName").classList.remove("sort-down")
                document.getElementById("eventName").classList.add("sort-up")
            } else {
                document.getElementById("eventName").classList.remove("sort-up")
                document.getElementById("eventName").classList.add("sort-down")
            }
        } else if (event == "creationDate") {
            accend = creationDateAccend
            if (creationDateAccend == true) {
                document.getElementById("creationDate").classList.remove("sort-down")
                document.getElementById("creationDate").classList.add("sort-up")
            } else {
                document.getElementById("creationDate").classList.remove("sort-up")
                document.getElementById("creationDate").classList.add("sort-down")
            }
        } else if (event == "quantity") {
            accend = quantityAccend
            if (quantityAccend == true) {
                document.getElementById("quantity").classList.remove("sort-down")
                document.getElementById("quantity").classList.add("sort-up")
            } else {
                document.getElementById("quantity").classList.remove("sort-up")
                document.getElementById("quantity").classList.add("sort-down")
            }
        } else if (event == "total") {
            accend = totalAccend
            if (totalAccend == true) {
                document.getElementById("total").classList.remove("sort-down")
                document.getElementById("total").classList.add("sort-up")
            } else {
                document.getElementById("total").classList.remove("sort-up")
                document.getElementById("total").classList.add("sort-down")
            }
        }

        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/shopping-list/shopping-list-sort/${event}/${accend}`, {
            method: 'GET',
            headers: new Headers({
                "content-Type": "application/json",
            })
        }).then(res => res.json())
            .then(res => {
                if (res.result == "success") {
                    if (event == "eventName") {
                        if (eventNameAccend == true) {
                            setEventNameAccend(false)
                        } else {
                            setEventNameAccend(true)
                        }
                    } else if (event == "creationDate") {
                        if (creationDateAccend == true) {
                            setCreationDateAccend(false)
                        } else {
                            setCreationDateAccend(true)
                        }
                    } else if (event == "quantity") {
                        if (quantityAccend == true) {
                            setQuantityAccend(false)
                        } else {
                            setQuantityAccend(true)
                        }
                    } else if (event == "total") {
                        if (totalAccend == true) {
                            setTotalAccend(false)
                        } else {
                            setTotalAccend(true)
                        }
                    }
                    setResponseList(JSON.parse(res.response).response)
                } else {
                    //  setIsLoading(false)
                    console.log("Error result ---->>>>")
                    //location.reload()
                }
            })
    }

    function handlePrintPage() {
        window.print()
    }

    function handleFriendListModal(event) {
        event.preventDefault()
        console.log('handleFriendListModal ----- ')
        document.getElementById("find-friend").reset()
        document.getElementById("find-friend-error").innerHTML = "";
        document.getElementById("find-friend-error").classList.remove("d-block");
        document.getElementById("find-friend-error").classList.add("d-none")
        // var friendListModal = document.getElementById("friendListBtn");
        // friendListModal.setAttribute("data-bs-toggle", "modal");
        // friendListModal.setAttribute("data-bs-target", "#friendListModal");
        document.getElementById('emailListId').value = '';

        window.dataLayer = window.dataLayer || []
        console.log(' window.dataLayer ---- ', window.dataLayer)
        if (window.dataLayer.length > 0) {
            if (window.dataLayer.includes("list_detail_friend")) {
            } else {
                window.dataLayer.push({ "event": "list_detail_friend" })
            }

        }
        //friendListModal.click();
    }
    // useEffect(() => {
    //     var searchParam = window.location.search
    //     var uri = searchParam.split("?")
    //     console.log("shopping-list",uri)
    //     // if (profileDetails && profileDetails.transient && uri && uri != null && uri.length > 0 && uri[1] != "DPSLogout=true") {
    //     //     history.push("/account/login?resume=prev")
    //     // }
    // }, [profileDetails])
    return (
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content c-shop-list-detail`} >
            {/* <Modal  giftId={giftIdRef.current} newListModalId="newListModal"/> */}
            {/* {successMsgState ?
                <div class={`alert ${successMsgState && successMsgState.tempB2IMsg ? 'alert-danger d-block' : successMsgState && successMsgState.accountSuccCreateMsg ? 'alert-success d-block' : successMsgState === 'true' ? 'alert-success d-block' : 'd-none'} `} role="alert">
                    {successMsgState && successMsgState.tempB2IMsg ? successMsgState.tempB2IMsg :
                        successMsgState && successMsgState.accountSuccCreateMsg ? successMsgState.accountSuccCreateMsg : successMsgState === 'true' ? 'List(s) successfully deleted.' : ''}
                </div>
                : ''} */}
            {profileDetails && !profileDetails.transient ?
                <>
                    <div className="row align-items-center cb-breadcrum-list gx-0">
                        <div className="col-md-11 header-padding-row">
                            <BreadCrumbsContainer breadCrumbs={breadCrumbs} pageType="ShoppingList"></BreadCrumbsContainer>
                        </div>
                        <div className="col-12 col-md-1 header-padding-row d-none d-lg-block">
                            <button className="btn btn-light c-print-btn text-end" type="button" onClick={handlePrintPage}>
                                <i className="bi bi-printer-fill" aria-hidden="true"></i>Print
                            </button>
                        </div>
                    </div>

                    {isLoading && <Loader />}
                    <div className={`${shoppingListErrorMsgRef.current && shoppingListErrorMsgRef.current ? "d-block" : "d-none"} alert alert-danger`}>
                        <span>{shoppingListErrorMsgRef.current && shoppingListErrorMsgRef.current ? shoppingListErrorMsgRef.current : ""}</span>
                    </div>
                    <div class="alert alert-danger" role="alert" id="list-error-id">
                        {errorRef.current}
                    </div>

                    <div id="delete-success" className="alert alert-success d-none" role="alert">
                        <p>List(s) successfully deleted.</p>
                    </div>
                    <div className="row page-min-height gx-0 c-shopping-list-item-padding">
                        <MyAccountCommonize />
                        <div id="content" className="col-lg-9 c-shopping-list-item-col">
                            <div className="row my-3 my-md-0">
                                <div className="col-6 col-md-6">
                                    <h1 className="c-account-list-heading">Shopping Lists</h1>
                                </div>
                                <div className="col-6 col-md-6 d-lg-none">
                                    <CbMobileLogOut />
                                </div>
                            </div>

                            <div className="row c-shopping-list-page align-items-center my-3">
                                <form className='col-8 col-md-9' onSubmit={handleShoppingListSearch} method="post" action="/" id="searchShoppingLists" data-hs-cf-bound="true">
                                    <div className="">
                                        <div className="row g-1">
                                            <label for="inputPassword3" className="d-none d-md-flex col-md-3 col-form-label c-shopping-list-label">Search Your Lists:</label>
                                            <div className="col-8 col-md-7">
                                                <input className="form-control" placeholder="List Name, Product Name, or Item #" maxlength="25" name="searchProduct" id="searchLists" type="text" />
                                            </div>
                                            <div className="col-2 col-md-2">
                                                <input type="submit" name="shoppingListSearch" className="btn btn-primary c-btn-search" value="Search" id="searchListsButton" />
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                <div className="col-4 col-md-3 text-end c-shop-list-font">
                                    <Link type="button" className="c-find-link fw-bold modal-link c-shopping-list-modal-btn" data-bs-toggle="modal" onClick={(e) => handleFriendListModal(e)} data-bs-target="#friendListModal" >
                                        Find a Friend's List
                                    </Link>
                                </div>
                                <div className="modal gx-0 fade c-modal c-shopping-list-modal-body" id="friendListModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                    <div className="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-md">
                                        <div className="modal-content">
                                            <button type="button" id="findFriendClose" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                            <div className="modal-body">
                                                <form onSubmit={handleFindFriendShoppingList} method="post" action="/" id="find-friend" className="col-12 form" data-hs-cf-bound="true">
                                                    <div className="container-fluid list-modal-body">
                                                        <div className="row">
                                                            <div className="col-12">
                                                                <h3 className="modal-title" id="defaultModalLabel">
                                                                    Find a Friend's List
                                                                </h3>
                                                                <p>
                                                                    Enter the email of the list owner below.
                                                                </p>
                                                            </div>
                                                            <div class="alert alert-danger d-none" role="alert" id="find-friend-error"></div>

                                                            <div className="row mb-3 align-items-center">
                                                                <label for="eventName" className="col-12 col-md-3 col-form-label">Email:</label>
                                                                <div className="col-12 col-md-7 c-shopping-modal-input-mobile">
                                                                    <input maxlength="256" id='emailListId' name="emailList" type="text" className="form-control" />
                                                                </div>
                                                            </div>
                                                            <div className="row justify-content-end form-submit">
                                                                <div className="col-auto">
                                                                    <input type="submit" className="col-auto btn btn-primary" value="Search" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p id="addList"></p>
                            <div className="c-list-bar">
                                <div className="c-listbar-left">
                                    <label className="m-hide">Selected lists</label>
                                    <input type="button" className="btn c-shop-btn" onClick={handleAddMultiShoppingListToCart} value="Add to Cart" />
                                    <input type="button" className="btn c-shop-btn" onClick={handleDeleteClick} value="Delete" />
                                </div>
                                <div className="c-listbar-right">
                                    <button type="button" className="button modal-short modal-link c-shopping-list-modal-btn c-shopping-new-list" data-bs-toggle="modal" data-bs-target="#newListModal">New List</button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 mb-5">

                                    <div className="c-list-table">
                                        <h1 class="c-mobile-list-heading d-block d-md-none d-lg-none">My Lists</h1>
                                        <ul className="c-shop-list list-account list-wishlist" id="listList">
                                            <li class="c-shop-list-item c-shop-list-header d-none d-md-flex">
                                                <div class="c-list-left">
                                                    <span class="c-shop-list-content c-shop-list-check">
                                                        <input type="checkbox" class="form-check-input" id="checkboxNoLabel" onClick={handleSelectAllCheckbox} />
                                                    </span>
                                                    <span class="c-shop-list-content c-shop-list-name">Name <p className="sort" id="eventName" style={{ cursor: "pointer" }} onClick={() => handleSortingChange("eventName")}></p></span>
                                                    <span class="c-shop-list-content c-shop-list-created">Created on <p className="sort" id="creationDate" style={{ cursor: "pointer" }} onClick={() => handleSortingChange("creationDate")}></p></span>
                                                    <span class="c-shop-list-content c-shop-list-items"># Items <p className="sort" id="quantity" style={{ cursor: "pointer" }} onClick={() => handleSortingChange("quantity")}></p></span>
                                                    <span class="c-shop-list-content c-shop-list-total">Total <p className="sort" id="total" style={{ cursor: "pointer" }} onClick={() => handleSortingChange("total")}></p></span>
                                                </div>
                                                <div class="c-list-right">
                                                    <span></span>
                                                </div>

                                                <div></div></li>
                                            <ul class="c-shop-list list-account list-wishlist" id="listList">
                                                {responseListRef ? responseListRef.map((item, index) => {
                                                    return (<>
                                                        {item && item.giftlistId ?
                                                            <li className="c-shop-list-item c-shop-list-body" id="removeShoppingList">
                                                                <div className="c-list-left">
                                                                    <span className="c-shop-list-content c-shop-list-check">
                                                                        <input type="checkbox" className="form-check-input" name="check" id={`${item.giftlistId}`} defaultValue="false" />
                                                                    </span>
                                                                    <span className="c-shop-list-content c-shop-list-name">

                                                                        <Link to={`/account/list-detail?giftlistId=${item.giftlistId}&isWishlist=${item.isWishlist}`} className="fw-bold">{item.Name}</Link><p>{item.Description}</p>
                                                                    </span>
                                                                    <span className="c-shop-list-content c-shop-list-created"><span className="d-block d-md-none c-shop-mobile-label">Created On</span>{item.comments}</span>
                                                                    <span className="c-shop-list-content c-shop-list-items">{item.quantity + " "}<span className="d-block d-md-none c-shop-mobile-label">Items</span></span>
                                                                    <span className="c-shop-list-content c-shop-list-total">
                                                                        <span className="d-block d-md-none c-shop-mobile-label">Total</span><strong>{item.total}</strong>
                                                                        {item && item.retailPrice && <span class="c-list-retail"><i>{`Retail `}<del>{item.retailPrice}</del></i></span>}
                                                                    </span>

                                                                </div>
                                                                <Modal index={index} giftlistId={item && item.giftlistId ? item.giftlistId : ""} props={addListToCartRef.current && addListToCartRef.current} invalidProduct={invalidProductRef.current} />
                                                                <div className="c-list-right text-end">
                                                                    <button type="button" className="btn c-shop-btn c-list-btn-action c-list-btn-items-mobile" data-bs-toggle="modal" index={index} onClick={emailButtonClose} data-bs-target={`#emailModal${index}`}>Email</button>
                                                                    <button type="button" className="btn c-shop-btn c-list-btn-action c-list-btn-items-mobile" data-bs-toggle="modal" index={index} onClick={handleCopy} data-bs-target={`#copyListModal${index}`}>Copy</button>
                                                                    <button id={`${item.giftlistId}`} onClick={handleRemoveOneShoppingItem} className="btn c-shop-remove">
                                                                        <i className="bi bi-x-circle-fill d-none d-md-block"></i>
                                                                    </button>
                                                                    <button id={`${item.giftlistId}`} className="item-remove btn c-shop-btn c-list-btn-action c-list-btn-items-mobile d-block d-md-none " onClick={handleRemoveOneShoppingItem}>
                                                                        <Link>Delete</Link>
                                                                    </button>
                                                                </div>
                                                            </li>
                                                            : ''}
                                                    </>)
                                                }) : ""}
                                            </ul>

                                        </ul>
                                    </div>
                                    <p id="copy-modal-id"></p>

                                </div>
                            </div>
                        </div>
                    </div>
                </> : ""}
        </div>

    )
}

export default ShoppingList
